import { EmptyValuePlaceholder } from "@/components/ui"
import { SingleLineAddressOnListing } from '@/components/Address'
import { capitalize } from '@/utils/strings'
import { formatPrice, formatSurface } from '@/utils/formatters'

export default ({ bien }) => {
  const handleCardClick = (bienId) => {
    window.location.href = `/extranet/proprietaire/biens/${bienId}`
  }

  // Fonction pour obtenir les prix selon les mandats
  const getPrixByMandats = () => {
    if (!bien.mandats_data || bien.mandats_data.length === 0) {
      return <EmptyValuePlaceholder value={formatPrice(bien.prix_vente || bien.prix_loyer)}/>
    }

    if (bien.mandats_data.length === 1) {
      const mandat = bien.mandats_data[0]
      return <EmptyValuePlaceholder value={formatPrice(mandat.prix_vente || mandat.prix_loyer)}/>
    }

    // Cas de plusieurs mandats : afficher les deux prix
    return (
      <div className='flex flex-col'>
        {bien.mandats_data.map((mandat, i) => (
          <div key={i}>
            <EmptyValuePlaceholder value={formatPrice(mandat.prix_vente || mandat.prix_loyer)} />
          </div>
        ))}
      </div>
    )
  }

  // Fonction pour obtenir les honoraires selon les mandats
  const getHonorairesByMandats = () => {
    if (!bien.mandats_data || bien.mandats_data.length === 0) {
      return <EmptyValuePlaceholder value={formatPrice(bien.montant_honoraires_ttc)}/>
    }

    if (bien.mandats_data.length === 1) {
      const mandat = bien.mandats_data[0]
      return <EmptyValuePlaceholder value={formatPrice(mandat.montant_honoraires_ttc)}/>
    }

    // Cas de plusieurs mandats : afficher les deux honoraires
    return (
      <div className='flex flex-col'>
        {bien.mandats_data.map((mandat, i) => (
          <div key={i}>
            <EmptyValuePlaceholder value={formatPrice(mandat.montant_honoraires_ttc)}/>
          </div>
        ))}
      </div>
    )
  }

  return (
    <div 
      className="card bg-primary-200 w-full md:w-[calc(50%-0.5rem)] cursor-pointer hover:shadow-xl hover:scale-[1.02] active:scale-[0.98] transition-all duration-300 border-2 border-primary-300 hover:border-primary-500"
      onClick={() => handleCardClick(bien.id)}
      data-object="bien" 
      data-id={bien.id}
    >
      <div className="card-body p-4 bg-base-200 relative">
        {/* Indicateur visuel de clic */}
        <div className="absolute top-2 right-2 text-primary-500">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </div>
        <div className="grid grid-cols-2 gap-2">

          <div className="text-sm font-medium text-gray-600">Statut</div>
          <div>
            { bien.type_mandats?.length < 2 && <EmptyValuePlaceholder value={bien.type_mandats[0]} className='capitalize'/>  }
            { bien.type_mandats?.length > 1 &&
                <div className='flex flex-col'>{
                  bien.type_mandats.map((mandat, i) => <div key={i} className="capitalize">{mandat}</div>)
                }</div>
            }
          </div>

          <div className="text-sm font-medium text-gray-600">Prix</div>
          <div>{getPrixByMandats()}</div>

          <div className="text-sm font-medium text-gray-600">Honoraires</div>
          <div>{getHonorairesByMandats()}</div>

          <div className="text-sm font-medium text-gray-600">GLI</div>
          <div><EmptyValuePlaceholder value={formatPrice(bien.montant_gli)} /></div>

          <div className="text-sm font-medium text-gray-600">Adresse</div>
          <div>
            <SingleLineAddressOnListing data={bien} withApptNumber={false} />
            { bien.type_bien === "appartement" && bien.numero_appartement && 
              <p>appt n° {bien.numero_appartement}</p>
            }
          </div>

          <div className="text-sm font-medium text-gray-600">Type</div>
          <div><EmptyValuePlaceholder value={capitalize(bien.type_bien)} /></div>

          <div className="text-sm font-medium text-gray-600">Surface</div>
          <div><EmptyValuePlaceholder value={formatSurface(bien.surface_carrez)} /></div>

          { Array.isArray(bien.locataires) && bien.locataires.length > 0 && (
            <>
              <div className="text-sm font-medium text-gray-600">Locataire</div>
              <div>
                {bien.locataires.map((loc, i) => <div key={i}>{loc.nom_complet}</div>)}
              </div>
            </>
          )}

        </div>
      </div>
    </div>
  )
}
